import React from 'react';
import ReactDOM from 'react-dom';

class IntroScreen extends React.Component{	

	componentWillReceiveProps(nextProps,nextState){
		if('isPlaying' in nextProps){
			//console.log('isPlaying' , nextProps.isPlaying);
		}
	}

	render(){
		return (
			<main className="intro video-element">
				<div className="intro video-element-inner active-video-0">
						<button className="center start-button" onClick={this.props.startIntro}>{this.props.content}</button>
				</div>
			</main>
			);
	}
}


export default IntroScreen;



// WEBPACK FOOTER //
// ./src/scripts/introScreen.js